<mat-card class="notification {{quality}}">
    <mat-icon *ngIf="quality == 'success'" class="icon">check_circle_outline</mat-icon>
    <mat-icon *ngIf="quality == 'info'" class="icon">info_outline</mat-icon>
    <mat-icon *ngIf="quality == 'warning'" class="icon">warning_outline</mat-icon>
    <div>
        <ng-content></ng-content>
    </div>
</mat-card>